// removed by extract-text-webpack-plugin
module.exports = {"container":"_2GoQ","title":"_2bLU","wrapper":"_2wrt","textContainer":"_3MJ9","contactWrapper":"_1w7g","contactAction":"qv8L","rasmusContact":"_1Z2o","cardIcon":"_3ohM","circleContainer":"_2Zn_","upperCircle":"_2zA8","lowerCircle":"_1JWV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/styles.scss
// module id = 409
// module chunks = 0